import { render, staticRenderFns } from "./BookingConfirm.vue?vue&type=template&id=35b9546d"
import script from "./BookingConfirm.vue?vue&type=script&lang=js"
export * from "./BookingConfirm.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirm.vue?vue&type=style&index=0&id=35b9546d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports